module.exports = __webpack_public_path__ + "img/logo.d4bf6033.png";